import script from "./CartPagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartPagination.vue?vue&type=script&lang=ts&setup=true"

import "./CartPagination.vue?vue&type=style&index=0&id=a089f5fa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a089f5fa"]])

export default __exports__